import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';

/** Brand-refresh floating Checkout UI only when REACT_APP_BRAND_REFRESH_ENABLED === 'true'. */
export const isCheckoutButtonBrandRefresh = () => isBrandRefreshEnabled();

/** data-region value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getCheckoutButtonRegionProps = () =>
  isBrandRefreshEnabled() ? 'checkout-button' : undefined;

/** Sticky CTA wrapper region (PageContainer float bar). */
export const getStickyCtaRegionProps = () =>
  isBrandRefreshEnabled() ? 'sticky-cta' : undefined;

/** data-part value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getCheckoutButtonPartProps = part =>
  isBrandRefreshEnabled() ? part : undefined;

/** Menu-page marker for menu sticky CTA gradient when brand refresh is on. */
export const getCheckoutButtonMenuProps = isMenuPage =>
  isBrandRefreshEnabled() && isMenuPage ? 'true' : undefined;

/**
 * Cart icon — brand-refresh SVG when flag on, else legacy.
 * Naming = button background the icon sits on (Figma):
 * - cart-icon-on-cream.svg → purple glyph (#3B0055) for Menu cream button
 * - cart-icon-on-yellow.svg → midnight glyph (#11001C) for yellow button
 */
export const getCheckoutCartIcon = (
  legacyIcon,
  brandRefreshIconOnYellow,
  brandRefreshIconOnCream,
  isMenuPage
) => {
  if (!isBrandRefreshEnabled()) {
    return legacyIcon;
  }
  return isMenuPage ? brandRefreshIconOnCream : brandRefreshIconOnYellow;
};

/** Menu: cream button / purple content. Other pages: yellow button / midnight content (Figma 12057:51445). */
export const getCheckoutButtonBrandRefreshColors = isMenuPage =>
  isMenuPage
    ? { backgroundColor: '#F1E8DE', color: '#3B0055', qtyColor: '#3B0055' }
    : { backgroundColor: '#EFFF00', color: '#11001C', qtyColor: '#11001C' };
